import { IClientProps, client } from '@/services/v2/client'
import { User } from 'containers/user/types/user'

const baseUrl = '/api/v1/users'

export const getProfile = async (username: string, options?: IClientProps) => {
  return await client<User>(baseUrl + `/${username}`, options)
}
